<template>
  <div>
    <div v-if="showStudent" style="margin-bottom: 5px;">
      <el-tag type="primary" size="mini" style="margin-right: 5px; cursor: pointer;"
        @click.native="row.isStudent && $emit('show-follow', 'student', row)" title="点击查看留学跟进详情">留学</el-tag>
      <el-link v-if="row.isStudent" type="primary" :underline="false" style="font-size: 12px; cursor: pointer;"
        @click.native="$emit('show-follow', 'student', row)" :title="(row.stuStatusName === '待分配' ? '已是留学资源，跟进状态未设置；' : '') + '点击查看留学跟进详情'">{{ row.stuStatusName || '跟进中' }}</el-link>
      <el-link v-else type="primary" :underline="false" style="font-size: 12px;">待分配</el-link>
    </div>
    <div v-if="showJap" style="margin-bottom: 5px;">
      <el-tag type="success" size="mini" style="margin-right: 5px; cursor: pointer;"
        @click.native="row.isJap && $emit('show-follow', 'jap', row)" title="点击查看日语跟进详情">日语</el-tag>
      <el-link v-if="row.isJap" type="primary" :underline="false" style="font-size: 12px; cursor: pointer;"
        @click.native="$emit('show-follow', 'jap', row)" :title="(row.jpStatusName === '待分配' ? '已是日语资源，跟进状态未设置；' : '') + '点击查看日语跟进详情'">{{ row.jpStatusName || '跟进中' }}</el-link>
      <el-link v-else type="primary" :underline="false" style="font-size: 12px;">待分配</el-link>
    </div>
    <div v-if="showMingye">
      <el-tag type="warning" size="mini" style="margin-right: 5px; cursor: pointer;"
        @click.native="row.isMingye && $emit('show-follow', 'mingye', row)" title="点击查看鸣野跟进详情">鸣野</el-tag>
      <el-link v-if="row.isMingye" type="primary" :underline="false" style="font-size: 12px; cursor: pointer;"
        @click.native="$emit('show-follow', 'mingye', row)" :title="(row.myStatusName === '待分配' ? '已是鸣野资源，跟进状态未设置；' : '') + '点击查看鸣野跟进详情'">{{ row.myStatusName || '跟进中' }}</el-link>
      <el-link v-else type="primary" :underline="false" style="font-size: 12px;">待分配</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherDeptFollow',
  props: {
    row: { type: Object, required: true },
    showStudent: { type: Boolean, default: true },
    showJap: { type: Boolean, default: true },
    showMingye: { type: Boolean, default: true }
  }
};
</script>
